import './CardsConfigCountries.scss';
// @vendor
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
const getCountryISO3 = require("country-iso-2-to-3");
// @utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const {
    isOnlyOriginCountryEnable,
    getNumberEnableCountries,
    needDisableOriginCountryZone,
    getNumberCountriesFromZone
} = require('utilities/cardControl/cardControlHelper')
// @components
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
import ChoroplethMulticolor, { ColorGroup } from 'components/charts/ChoroplethMulticolor/ChoroplethMulticolor';
import { getCard } from 'selectors/cards';
import CountriesList from './CountriesList';
import fixUnchartedCountries from './fixUnchartedCountries';
// @actions
import {
    countriesFilterChanged,
    countriesFilterReset,
    countriesOnlySetRequested,
    countrySetRequested,
    zoneSetRequested,
    zoneSelected,
    originCountryZoneSucceeded
} from 'actions/cardControl';
// @assets
const infoIcon = require('assets/images/info-icon.png'); //@hardcoded: replace Icon placeholder
// @constants
const {
    CYAN_ACCENT,
    WEALTH_MIX,
    YELLOW_BASE,
} = require('constants/colors');

class CardsConfigCountries extends Component {
    constructor(props) {
        super(props);
        this.closeButton = null;
    }

    componentDidMount() {
        const { resetFilter } = this.props;
        resetFilter(); 
    }

    zoneColor(zone) {
        if (zone.countries.every(country => country.enabled)) return CYAN_ACCENT;
        if (zone.countries.some(country => country.enabled)) return YELLOW_BASE;
        return WEALTH_MIX;
    }

    onClickOriginCountryZone(originCountry) {
      const { card, setOnlyCountries, setDisableOriginCountryZone } = this.props
      const originCountryZone = JSON.parse(JSON.stringify(card.originCountryZone))
      originCountryZone.enabled = !originCountryZone.enabled
      if (card.originCountryZone.enabled) {
        setDisableOriginCountryZone({
          cardId: card.cardId,
          originCountryZone
        })
      } else {
        setOnlyCountries({
            cardId: card.cardId,
            countriesIds: [getCountryISO3(originCountry)],
            pan: card.contract.number.padStart(card.contract.number.length, '0'),
            originCountryZone,
            lastDigitsPan: card.number.slice(-4),
        })
      }
    }

    onCountryClick(countryId, active) {
        const { card, setCountry, setDisableOriginCountryZone } = this.props
        const numberCountries = getNumberEnableCountries(card.locations) + (!active ? 1 : -1)
        const needDisableCountryZone = needDisableOriginCountryZone(numberCountries, card.originCountryZone)
        if(needDisableCountryZone) {
            setDisableOriginCountryZone({
                cardId: card.cardId,
                originCountryZone: needDisableCountryZone
              })
        }
        setCountry({
            active: !active,
            cardId: card.cardId,
            countryId,
            pan: card.contract.number.padStart(card.contract.number.length, '0'),
            lastDigitsPan: card.number.slice(-4),
        })
    }

    onZoneClick(zoneId, active) {
        const { card, setZone, setDisableOriginCountryZone } = this.props;
        const countries = getNumberCountriesFromZone(card.locations, zoneId)
        const numberCountries = getNumberEnableCountries(card.locations) + (!active ? countries : -countries)
        const needDisableCountryZone = needDisableOriginCountryZone(numberCountries, card.originCountryZone)
        if(needDisableCountryZone) {
            setDisableOriginCountryZone({
                cardId: card.cardId,
                originCountryZone: needDisableCountryZone
              })
        }
        setZone({
            active: !active,
            cardId: card.cardId,
            pan: card.contract.number.padStart(card.contract.number.length, '0'),
            zoneId,
            lastDigitsPan : card.number.slice(-4),
        })
    }

    renderOriginCountryZone = (originCountry) => {
      const countryCode = getCountryISO3(originCountry);
      return (
          <ColorGroup
              color={CYAN_ACCENT}
              countries={[countryCode]}
              key={countryCode}
          />
      )
    }

    renderSearchIcons = (filter) => {
        const { changeFilter } = this.props;
        const styleTagI = { fontSize: '16px' };

        if (!!filter) {
            return (
                <div
                    onClick={() => changeFilter('')}>
                    <OKTooltip
                        content="cardsConfig-tooltipCancel"
                        offset={[0, -15]}
                        target={<i style={styleTagI} className="icon-cerrar" />}
                        type="descriptive" />
                </div>
            );
        }

        return (
            <OKTooltip
                content="cardsConfig-tooltipSearch"
                offset={[0, -15]}
                target={<i style={styleTagI} className="icon-s-buscar" />}
                type="descriptive"
            />
        )
    }

    render() {
        const { card, changeFilter, filter, immProfile, selectZone, zoneSelected } = this.props;

        // Disable view if tpv channel is inactive
        const conceal = (card && card.channels) ? !card.channels.tpv && !card.channels.atm : false;
        const classConceal = (conceal) ? "conceal" : ""
        const originCountry = immProfile.get('originCountry');

        const concealNotification = (
            <section className="info-box col-xs-12">
                <div className="mobile-login-header">
                    <div className="mobile-login-header__info-icon">
                        <img src={infoIcon} alt={formatText('cardsConfig-infoDisabledCountriesAlt')}/>
                    </div>
                    <div className="mobile-login-header__info-text">
                        <FormattedText className="" value="cardsConfig-infoDisabledCountriesDesc" />
                    </div>
                </div>
            </section>
        )

        return (
            <section className="card-countries row">
                {conceal && concealNotification}
                <div className={classConceal}>
                    <section className="map-box col-xs-12">
                        <ChoroplethMulticolor>
                            {
                                card.locations && isOnlyOriginCountryEnable(card.locations, originCountry) ?
                                this.renderOriginCountryZone(originCountry) : card.locations &&
                                card.locations.map(zone => (
                                    <ColorGroup
                                        color={this.zoneColor(zone)}
                                        countries={
                                            zone.countries
                                            .map(country => country.name)
                                            .reduce(fixUnchartedCountries, [])
                                        }
                                        key={zone.code}
                                    />
                                ))
                            }
                        </ChoroplethMulticolor>
                    </section>
                    <section className="legend-box col-xs-12">
                        <div className="legend-item">
                            <span className="item--circle enabled" />
                            <p className="item--text">
                                {formatText('cardsConfig-active')}
                            </p>
                        </div>
                        <div className="legend-item">
                            <span className="item--circle partially-enabled" />
                            <p className="item--text">
                                {formatText('cardsConfig-semiActive')}
                            </p>
                        </div>
                        <div className="legend-item">
                            <span className="item--circle disabled" />
                            <p className="item--text">
                                {formatText('cardsConfig-inactive')}
                            </p>
                        </div>
                    </section>
                    <section className="search-box col-lg-12 col-md-12 col-xs-12">
                        <div className="container-search-disclaimer">
                            <FormattedText className="" value="cardsConfig-searchDisclaimer" />
                        </div>
                        <div className="container-search input-group">
                            <input
                                onChange={({ target: { value } }) => changeFilter(value)}
                                className="form-control"
                                placeholder={formatText('cardsConfig-searchCountries')}
                                value={filter}
                                disabled={conceal}
                            />
                            <span className="input-group-addon">
                                {this.renderSearchIcons(filter)}
                            </span>
                        </div>
                    </section>
                    <section className="list-box col-xs-12">
                        {
                            card.locations &&
                            <CountriesList
                                data={card.locations}
                                filter={filter}
                                onCountryClick={(countryId, active) => this.onCountryClick(countryId, active)}
                                onZoneClick={(zoneId, active) => this.onZoneClick(zoneId, active)}
                                onZoneSelect={code => selectZone(code)}
                                originCountry={originCountry}
                                zoneSelected={zoneSelected}
                                originCountryZone={card.originCountryZone}
                                onClickOriginCountryZone={() => this.onClickOriginCountryZone(originCountry)}
                                conceal={conceal}
                            />
                        }
                    </section>
                </div>
            </section>
        );
    }
}


CardsConfigCountries.propTypes = {
    card: PropTypes.object.isRequired,
    changeFilter: PropTypes.func.isRequired,
    filter: PropTypes.string.isRequired,
    immProfile: PropTypes.object.isRequired,
    resetFilter: PropTypes.func.isRequired,
    selectZone: PropTypes.func.isRequired,
    setCountry: PropTypes.func.isRequired,
    setOnlyCountries: PropTypes.func.isRequired,
    setZone: PropTypes.func.isRequired,
    zoneSelected: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    setDisableOriginCountryZone: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
    card: getCard(state, props),
    filter: state.cardControl.countriesFilter,
    immProfile: state.profile,
    zoneSelected: state.cardControl.zoneSelected,
});

const mapDispatchToProps = dispatch => ({
    changeFilter: value => dispatch(countriesFilterChanged({ value })),
    resetFilter: () => dispatch(countriesFilterReset()),
    setOnlyCountries: ({ cardId, countriesIds, pan, originCountryZone, lastDigitsPan }) => dispatch(countriesOnlySetRequested({ cardId, countriesIds, pan, originCountryZone, lastDigitsPan })),
    setDisableOriginCountryZone: ({ cardId, originCountryZone }) => dispatch(originCountryZoneSucceeded({ cardId, originCountryZone })),
    selectZone: (code) => dispatch(zoneSelected({ code })),
    setCountry: ({ active, cardId, pan, countryId, lastDigitsPan }) => dispatch(countrySetRequested({ active, cardId, pan, countryId, lastDigitsPan })),
    setZone: ({ active, cardId, pan, zoneId, lastDigitsPan }) => dispatch(zoneSetRequested({ active, cardId, pan, zoneId, lastDigitsPan })),
});


export default connect(mapStateToProps, mapDispatchToProps)(CardsConfigCountries);
